import React from 'react';
import { Users } from 'lucide-react';
import Button from '@components/common/Button';
import styles from './CombineButtonContainer.module.css';

export interface CombineButtonContainerProps {
  selectedCount: number;
  onCombine: () => void;
  onDeselectAll: () => void;
  className?: string;
}

const CombineButtonContainer: React.FC<CombineButtonContainerProps> = ({ selectedCount, onCombine, onDeselectAll }) => {
  return (
    <>
      <Button variant="primary" size="sm" onClick={onCombine}>
        <Users size={16} className={styles.btnIcon} />
        Combine ({selectedCount})
      </Button>
      <Button variant="ghost" size="sm" onClick={onDeselectAll}>
        Deselect All
      </Button>
    </>
  );
};

export default CombineButtonContainer;
